/**
 * @file        src/pages/hotel/CorporateAmendmentMarkup.jsx
 * @description Corporate Hotel → Amendment Markup. The B2C screen's component
 *              (AmendmentMarkup.jsx) fixed to audience=b2b.
 * @author      Kinetika Labs
 * @created     2026-10-10
 * @changelog
 *   - 2026-10-10 Claude — Initial.
 */
import HotelAmendmentMarkup from './AmendmentMarkup';

export default function CorporateHotelAmendmentMarkup() {
  return (
    <HotelAmendmentMarkup
      title="Corporate Amendment Markup"
      subtitle="Corporate Hotel · our markup on cancellations"
      audience="b2b"
    />
  );
}
